/*
 * @Author: caiqin.xie
 * @since: 2023-06-28 17:12:46
 * @lastTime: 2023-10-20 16:17:42
 * @LastEditors: caiqin.xie
 * @message: 邮件反馈--附件上传
 */
import React, { useRef } from "react";
import { Input, Message } from '@arco-design/web-react';
import { IconClose } from "@arco-design/web-react/icon";
import styles from "../../index.module.scss";

interface IProps {
  words: Record<string, string>;
  fileName: string; // 文件名
  setFileName: (fileName: string) => void; // set文件名
  setFileList: (fileList: any) => void; // set文件列表
}

const UploadFile = (props: IProps) => {
  const { words, setFileList, fileName, setFileName } = props;

  const fileRef = useRef<any>();

  // 文件上传
  const fileChange = () => {
    if (fileRef.current.files.length > 0) {
      const {name, size} = fileRef.current.files[0]
      const maxSize = 1024 * 1024 * 15
      if (size > maxSize) {
        Message.error(words?.support_email_us_file_size)
        return false
      }
      setFileName(name)
      setFileList(fileRef.current.files)
    }
  }

  // 清除文件
  const clearFile = () => {
    fileRef.current.value = ''
    setFileName('')
    setFileList([])
  }

  return (
    <div className={styles['file-input-wrap']}>
      <div className={styles['file-input']}>
        <div className={styles['file-input-name']}>
          <Input readOnly placeholder={words?.support_email_us_upload_placeholder} value={fileName} />
          {fileName && <i className={styles['close']} onClick={clearFile}><IconClose /></i>}
        </div>
        <label htmlFor="file" className={styles['file-btn']}>{words?.support_email_us_upload}</label>
        <input ref={fileRef} type="file" name="file" id="file" className={styles['hidden-input']} onChange={fileChange} />
      </div>
      <p className={styles['file-tips']}>{words?.support_email_us_file_size}</p>
    </div>
  )
}
export default UploadFile;